import { AzureBlobFSLocationAdapter } from 'app/model/adapters/datasets/location/azure-blobfs.location.adapter';
import { AdapterRegistry, IModel, Metamodel, SapDatasphereForAzureDataLakeStorageGen2Location } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapDatasphereForAzureDataLakeStorageGen2Location)
})
export class SapDatasphereForAzureDataLakeStorageGen2LocationAdapter extends AzureBlobFSLocationAdapter {
    protected override model(): IModel {
        return SapDatasphereForAzureDataLakeStorageGen2Location.MODEL;
    }
}
